import { useRoutes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import LoginForm from '../components/Login/LoginForm';
import RegistrationForm from '../components/Registration/RegistrationForm';
import RestoreForm from '../components/Restore/RestoreForm';
import RestorePasswordForm from '../components/RestorePassword/RestorePasswordForm';
import HomePage from '../components/HomePage/HomePage';
import NotFoundPage from '../components/NotFoundPage/NotFoundPage';
import EditProfilePage from '../components/EditProfile/EditProfile';
import ProtectedRoute from './ProtectedService';
import UserApplicationsPage from '../components/UserApplicationsPage/UserApplicationsPage';
import CertificationsPage from '../components/CertificationsPage/CertificationsPage';
import CertificationEdit from '../components/CertificationPage/CertificationEdit/CertificationEdit';
import CertificationInfo from '../components/CertificationPage/CertificationInfo/CertificationInfo';
import CertificationApply from '../components/CertificationPage/CertificationApply/CertificationApply';
import AdminApplicationsPage from '../components/AdminApplicationsPage/AdminApplicationsPage';
import CertificationReview from '../components/CertificationPage/CertificationReview/CertificationReview';

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <HomePage /> },
    { path: "login", element: <LoginForm /> },
    { path: "registration", element: <RegistrationForm /> },
    { path: "restore", element: <RestoreForm /> },
    { path: "restore/:link", element: <RestorePasswordForm /> },
    { path: "certifications", element: <CertificationsPage /> },
    // { path: "news", element: <NewsPage /> },
    // { path: "certified-users", element: <CertifiedUsersPage /> },
    { path: "certifications/:id/edit", element: <ProtectedRoute><CertificationEdit /></ProtectedRoute>},
    { path: "certifications/:id/apply", element: <ProtectedRoute><CertificationApply /></ProtectedRoute>},
    { path: "certifications/:id", element: <CertificationInfo /> },
    { path: "certifications/user", element: <ProtectedRoute><UserApplicationsPage /></ProtectedRoute> },
    { path: "edit-profile", element: <ProtectedRoute><EditProfilePage /></ProtectedRoute> },
    { path: "admin/applications", element: <ProtectedRoute><AdminApplicationsPage /></ProtectedRoute> },
    { path: "admin/applications/:id", element: <ProtectedRoute><CertificationReview/></ProtectedRoute> },
    { path: "*", element: <NotFoundPage /> }
  ]);

  return routes;
};

export default observer(AppRoutes);
